import { render, staticRenderFns } from "./scjd.vue?vue&type=template&id=53200c84&scoped=true&"
import script from "./scjd.vue?vue&type=script&lang=js&"
export * from "./scjd.vue?vue&type=script&lang=js&"
import style0 from "./scjd.vue?vue&type=style&index=0&id=53200c84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53200c84",
  null
  
)

export default component.exports